import type { CSSProperties } from 'react';

/** Cor que é dado (a do ministério, a da série), com o par do tema escuro. */
export type Tone = {
  color: string;
  tint: string;
  dark: { color: string; tint: string };
};

/**
 * As variáveis que `text-tone` e `bg-tone-tint` (em `tokens.css`) leem: o tema escolhe
 * entre o par claro e o escuro sem o componente saber qual está ligado.
 */
export function toneStyle(tone: Tone): CSSProperties {
  return {
    '--tone': tone.color,
    '--tone-tint': tone.tint,
    '--tone-dark': tone.dark.color,
    '--tone-tint-dark': tone.dark.tint,
  } as CSSProperties;
}
